export default __webpack_public_path__ + "static/media/sentmessage.078c78c4.mp3";